export function lockBodyScroll(): void {
	if (window.browserDetectSingleton) {
		window.browserDetectSingleton.setScrollbarWidthOffset()
	}

	setBodyOverflow(true)
}

export function unlockBodyScroll(): void {
	setBodyOverflow(false)
}

function setBodyOverflow(isHidden: boolean): void {
	document.body.style.overflow = isHidden ? 'hidden' : ''
	document.body.classList.toggle('gb-scroll-disabled', isHidden)
}
